export default __webpack_public_path__ + "033c5cbd01469bff349cdcf8678f0f3b.png";